"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZSorter = void 0;
const React = __importStar(require("react"));
const ZMultiSelect_1 = require("../ZMultiSelect/ZMultiSelect");
const ZTooltip_1 = require("../ZTooltip/ZTooltip");
const ll_1 = require("../../languages/ll");
const schema_1 = require("../../utils/schema");
const lodash_1 = __importDefault(require("lodash"));
const styled_components_1 = __importStar(require("styled-components"));
const FlexBox = styled_components_1.default.div `
   display: flex;
`;
function getArrow(v) {
    return v && v.dir ? (v.dir === "asc" ? "↑" : "↓") : "";
}
function toggleDir(dir) {
    return dir === "asc" ? "desc" : "asc";
}
function clickedClose(e) {
    return e.nativeEvent.target.classList.contains("k-i-close");
}
const ZSorterComponent = (props) => {
    const { fields, initialValue, className, localize, onChange, maxSorts, ...multiSelectProps } = props;
    const theme = React.useContext(styled_components_1.ThemeContext);
    const getDisplayName = React.useCallback((v) => {
        const field = fields.find(f => typeof f === "object" ? f.field === v.field : f === v.field);
        return ll_1.ll(typeof field === "object"
            ? field.label
            : schema_1.splitLast(v.field)[1] || "Unknown");
    }, [fields]);
    const data = React.useMemo(() => fields.map(f => ({
        field: typeof f === "string" ? f : f.field,
        dir: "asc"
    })), [fields]);
    const [value, setValue] = React.useState(initialValue || []);
    const tags = React.useMemo(() => value.map(v => {
        const displayName = getDisplayName(v);
        return {
            text: `${displayName} ${getArrow(v)}`,
            data: [v]
        };
    }), [value, getDisplayName]);
    return (React.createElement("div", { className: className },
        React.createElement(ZMultiSelect_1.ZMultiSelect, Object.assign({}, multiSelectProps, { value: value, onChange: e => {
                if (clickedClose(e)) {
                    setValue(e.value);
                    onChange && onChange(e);
                    return;
                }
                if (maxSorts && e.value.length > maxSorts)
                    return;
                if (e.value.length < value.length) {
                    const clickedField = lodash_1.default.xorBy(value, e.value, "field")[0];
                    if (clickedField.dir === "asc") {
                        const newValue = value.map((v) => v.field === clickedField.field
                            ? { ...v, dir: "desc" }
                            : v);
                        setValue(newValue);
                        onChange && onChange({ ...e, value: newValue });
                        return;
                    }
                }
                setValue(e.value);
                onChange && onChange(e);
            }, localize: localize || true, data: data, tags: tags, dataItemKey: "field", itemRender: (li, item) => {
                const field = item.dataItem.field;
                const displayName = getDisplayName({ field });
                const selected = value.find(v => v.field === field);
                const disabled = maxSorts && value.length >= maxSorts;
                const color = selected
                    ? theme["action-button-hover-text-color"]
                    : disabled
                        ? theme["disabled-color"]
                        : "";
                const itemText = `${displayName} ${getArrow(selected)}`;
                return React.cloneElement(li, {
                    style: {
                        ...li.props.style,
                        color
                    }
                }, disabled && !selected ? (React.createElement(ZTooltip_1.ZTooltip, { title: "SortLimitReached", variables: [maxSorts] },
                    React.createElement("span", null, itemText))) : (itemText));
            }, tagRender: (tagData, li) => React.cloneElement(li, li.props, React.createElement(FlexBox, { onClick: e => {
                    if (clickedClose(e)) {
                        return;
                    }
                    const newValue = value.map(v => v.field === tagData.data[0].field
                        ? {
                            ...v,
                            dir: toggleDir(v.dir)
                        }
                        : v);
                    setValue(newValue);
                    onChange &&
                        onChange({
                            value: newValue,
                            syntheticEvent: e,
                            nativeEvent: e.nativeEvent,
                            target: null
                        });
                } }, li.props.children)) }))));
};
exports.ZSorter = styled_components_1.default(ZSorterComponent) `
   width: ${p => p.width || "300"}px;
   & .k-multiselect .k-multiselect-wrap .k-button .k-select,
   & .k-multiselect .k-multiselect-wrap .k-button .k-select:hover,
   & .k-multiselect .k-multiselect-wrap .k-button:hover .k-select {
      background-color: transparent;
   }
`;
//# sourceMappingURL=ZSorter.js.map